export default function DocIco() {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9925 8.7513V5.66797C14.9925 4.26784 14.9925 3.56777 14.72 3.03299C14.4803 2.56259 14.0979 2.18014 13.6275 1.94045C13.0927 1.66797 12.3926 1.66797 10.9925 1.66797H5.65918C4.25905 1.66797 3.55898 1.66797 3.0242 1.94045C2.5538 2.18014 2.17135 2.56259 1.93166 3.03299C1.65918 3.56777 1.65918 4.26784 1.65918 5.66797V14.3346C1.65918 15.7348 1.65918 16.4348 1.93166 16.9696C2.17135 17.44 2.5538 17.8225 3.0242 18.0622C3.55898 18.3346 4.25905 18.3346 5.65918 18.3346H8.32585M9.99251 9.16797H4.99251M6.65918 12.5013H4.99251M11.6592 5.83464H4.99251M13.3258 17.5013V12.5013M10.8258 15.0013H15.8258"
        stroke="#344054"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
